import { render, staticRenderFns } from "./TaskDemo.vue?vue&type=template&id=0fba1eee&scoped=true"
import script from "./TaskDemo.vue?vue&type=script&lang=js"
export * from "./TaskDemo.vue?vue&type=script&lang=js"
import style0 from "./TaskDemo.vue?vue&type=style&index=0&id=0fba1eee&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba1eee",
  null
  
)

export default component.exports